import React from "react";
import { ClientColyseusContext } from "../../contexts/ClientColyseusContext.js";
import Button from "../Button.js";
import Option from "../Option.js";
import Timer from "../PageQuiz/Timer.js";
import PageQuizMultiplayer from "./PageQuizMultiplayer.js";

class PageLobby extends React.Component {
  static contextType = ClientColyseusContext;
  //const { roomClients } = useContext(ClientColyseusContext);

  constructor(props) {
    super(props);
    this.state = {
      Courses: [],
      course: null,
      name: "My room",
      maxPlayer: 2,
      pwd: "",
      nbQuestions: 5,
      isStarted: false,
      timer: 3,
      mod: "speed_duel",
      connectedClient:[],
      clientName:"",
    };
  }


  /*componentDidMount() {
    const { location } = this.props;
  
    // If room configurations are passed as state, use them
    if (location.state && location.state.roomConfig) {
      this.setState({ ...location.state.roomConfig });
    }
  }*/
  

  componentWillUnmount() {
    this.context.room.leave();
  }

  componentDidMount() {
    console.log(this.context);
    const { location } = this.props;
  
    // If room configurations are passed as state, use them
    if (location.state && location.state.roomConfig) {
      this.setState({ ...location.state.roomConfig });
    }
//console.log(this.context.room.clients);
//this.setState({ clientName: this.contextType.clientName });
//console.log( this.state.clientName);
    const idRoom = this.props.location.pathname.split("/")[2];
    console.log(idRoom);
    if (!this.context.room || this.context.room.id !== idRoom)
      this.context.joinById(idRoom);
    const roomDetails = this.props.location.state; // Make sure to handle the case where state might be undefined
    if (roomDetails) {
        this.setState({
          course: roomDetails.course,
          course_id: roomDetails.course_id,
          nbQuestions: roomDetails.nbQuestions,
          // Set other details as necessary
        });
      }
      console.log(roomDetails);

    if (this.context.isMaster) {
    }
    
  }
   
  startGame = (contextClientColyseus) => {
    return new Promise((resolve, reject) => {
      try {
        // First operation: sending room updates
        contextClientColyseus.room.send('update', {
          roomPwd: this.state.pwd,
          roomName: this.state.name,
          course: this.props.location.state.course,
          course_id: this.props.location.state.course_id,
          nbQuestions: this.props.location.state.nbQuestions,
          TimePerQuestion:this.props.location.state.TimePerQuestion
        });
  
        // Second operation: starting the game
        contextClientColyseus.room.send("start", {
          message: "let's go!",
        });
  
        // Updating the state
        this.setState({ 
          timer: 3,
        });

  
        // If everything executes successfully, resolve the promise
        resolve("Game started successfully.");
      } catch (error) {
        // If there's an error, reject the promise with the error message
        reject(error);
      }
    });
  }

  render() {
    return (
      <ClientColyseusContext.Consumer>
        {(contextClientColyseus) => {
          if (this.state.isStarted)
          return <PageQuizMultiplayer room={contextClientColyseus.room} />;

            
            const isReadyToStart =
          contextClientColyseus.isMaster ;
        //  &&  contextClientColyseus.rooms.clients >= 2;
         //const clients = this.context.room.state.clients;
         console.log(contextClientColyseus.roomClients)
         console.log(contextClientColyseus.roomClients.length);
         console.log(this.state.course, this.state.course_id, this.state.nbQuestions);
         console.log(this.props.location.state)
         //console.log(this.props.location.state.course)
         //console.log(this.props.location.state.course_id)
         //console.log(this.props.location.state.nbQuestions)
 

          if (contextClientColyseus.isStarted)
            return (
              <Timer
                time={this.state.timer}
                isPaused={this.state.isStarted}
                isFinished={this.state.isStarted}
                action={() => {
                  this.setState({ timer: this.state.timer - 1 });
                }}
                onEnd={() => {
                  this.setState({ timer: 1, isStarted: true });
                }}
              />
            );
          if (contextClientColyseus.isMaster) {
            if (this.state.Courses.length === 0)
              fetch(process.env.REACT_APP_API_URL + "/course")
                .then((res) => res.json())
                .then((res) => {
                  this.setState({
                    Courses: res.courses,
                    course: res.courses[0].course_title,
                    course_id: res.courses[0].course_id,
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
                return (
                  <div className="container mt-5" style={{ marginTop: "100px"}}>
                    <h3>Your Id: {contextClientColyseus.clientName}</h3>
                    <div className="table-responsive">
                      <table className="table">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">Player</th>
                            <th scope="col">Session Id</th>
                          </tr>
                        </thead>
                        <tbody>
                          {contextClientColyseus.roomClients.map((client, index) => (
                            <tr key={index}>
                              <td>Player {index + 1}</td>
                              <td>{client}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-4">
                      {contextClientColyseus.roomClients.length > 1 ? (
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            this.startGame(contextClientColyseus)
                              .then((successMessage) => console.log(successMessage))
                              .catch((errorMessage) => console.error(errorMessage));
                          }}
                        >
                          Start
                        </button>
                      ) : (
                        <>
                          <button className="btn btn-secondary" disabled>
                            Waiting for players...
                          </button>
                          <p className="mt-3">
                            Share link to room with friends:{" "}
                            <a href={`https://syntax-map-pro-front.vercel.app/multiplayer/${contextClientColyseus.room.id}`}>
                              https://syntax-map-pro-front.vercel.app/multiplayer/{contextClientColyseus.room.id}
                            </a>
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                );
                
          }
          return (
            <div className="text-center mt-5" style={{ marginTop: "100px"}}>
              <h3>Your ID: {contextClientColyseus.clientName}</h3>
              <p className="mt-3">Waiting for the owner to start the game...</p>
            </div>
          );
        }}
      </ClientColyseusContext.Consumer>
    );
  }
}

export default PageLobby;
